export default [
    // {
    //     id: "312US-001",
    //     name: "CTI Clinical Research Center - PPDS",
    // },
    {
        id: "312US-002",
        name: "Road Runner Research Ltd",
    },
    {
        id: "312US-003",
        name: "Childrens Hospital of Wisconsin",
    },
    {
        id: "312US-004",
        name: "Nemours Children Clinic Wilmington",
    },
    {
        id: "312US-005",
        name: "Rady Childrens Hospital San Diego - PIN",
    },
    {
        id: "312US-006",
        name: "Ann & Robert H. Lurie Children's Hospital of Chicago",
    },
    {
        id: "312US-007",
        name: "Johns Hopkins University",
    },
    {
        id: "312US-008",
        name: "Tri-Valley Sleep Center",
    },
    /*{
        id: "312US-009",
        name: "Atlanta Diabetes Associates",
    },*/
    {
        id: "312US-010",
        name: "Santa Monica Clinical Trials",
    },
    {
        id: "312US-011",
        name: "Maimonides Medical Center-920 48th St",
    },
    {
        id: "312US-012",
        name: "Center of Excellence in Diabetes and Endocrinology",
    },
    {
        id: "312US-013",
        name: "Texas Valley Clinical Research, LLC",
    },
    {
        id: "312US-014",
        name: "Texas Children's Hospital-6701 Fannin St",
    },
    {
        id: "312US-015",
        name: "Emory University School of Medicine",
    },
    // {
    //     id: "312US-016",
    //     name: "Rare Disease Research, LLC",
    // },
    {
        id: "312US-017",
        name: "Childrens Hospital Colorado",
    },
    {
        id: "312US-018",
        name: "Montefiore Medical Center -111 East 210th Street",
    },
    {
        id: "312US-019",
        name: "Mayo Clinic - PPDS",
    },
    {
        id: "312US-020",
        name: "Center for Human Genetics",
    },
    /*{
        id: "312US-021",
        name: "Nationwide Children's Hospital",
    },*/
    {
        id: "312US-022",
        name: "Riley Children's Specialist Carmel",
    }
];
